module.exports = __webpack_public_path__ + "static/media/manual_edit_image.b923f855.jpg";